import React, { useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import InsertRegister from './srceens/InsertRegister';
import ManagementRegister from './srceens/ManagementRegister';
import { useUser } from '../../auth/UseUser';
import Sidebar from '../SideBar';
import { ReactComponent as Registar } from '../../assets/svg/Registri/Registar.svg';
import { ReactComponent as Regulation } from '../../assets/svg/Registri/Regulation.svg';
import { ReactComponent as PretrazivanjePropisa } from '../../assets/svg/Registri/PretrazivanjePropisa.svg';
import { ReactComponent as PromenaNadleznosti } from '../../assets/svg/Registri/PromenaNadleznosti.svg';
import { ReactComponent as MereKapaciteta } from '../../assets/svg/Registri/MereKapaciteta.svg';
import { ReactComponent as UnosMere } from '../../assets/svg/Registri/UnosMere.svg';
import { ReactComponent as UpravljanjeMerama } from '../../assets/svg/Registri/UpravljanjeMerama.svg';
import { ReactComponent as FinansijskiObrazac } from '../../assets/svg/Registri/FinansijskiObrazac.svg';
import { ReactComponent as UpravljanjeFinansijskihIzvestaja } from '../../assets/svg/Registri/UpravljanjeFinansijskihIzvestaja.svg';
import { ReactComponent as ProcenaFinansijskihIzvestaja } from '../../assets/svg/Registri/ProcenaFinansijskihIzvestaja.svg';

function Register() {
	let { user } = useUser();
	let navigate = useNavigate();
	const location = useLocation();
	const [screen, setScreen] = useState('default');

	const screenMap = {
		insertRegister: <InsertRegister />,
		managementRegister: <ManagementRegister />,
	};
	const menuList = [
		{
			name: 'Регистри',
			icon: <Registar />,
			subMenus: [
				{
					name: 'insertRegister',
					title: 'Унос прописа',
					url: '/register/insert',
					roles: ['Координатор', 'Администратор', 'Уносилац података'],
					icon: <Regulation />,
				},
				{
					name: 'managementRegister',
					title: 'Претраживање / брисање / измена прописа',
					url: '/register/management',
					icon: <PretrazivanjePropisa />,
				},
				{
					name: 'changejur',
					title: 'Промена надлежности корисника',
					url: '/register/changejur',
					roles: ['Координатор'],
					icon: <PromenaNadleznosti />,
				},
			],
		},
		{
			name: 'Мере за успостављање институционалних и административних капацитета',
			icon: <MereKapaciteta />,
			subMenus: [
				{ name: 'addMeasure', title: 'Унос мере', url: '/register/addmeasure', icon: <UnosMere /> },
				{
					name: 'measure/management',
					title: 'Управљање мерама',
					url: '/register/measure/management',
					icon: <UpravljanjeMerama />,
				},
			],
		},
		{
			name: 'Процена финансијских ефеката',
			icon: <ProcenaFinansijskihIzvestaja />,
			subMenus: [
				{
					name: 'financial/expenditure/insert',
					title: 'Образац за процену финансијских ефеката НПАА',
					url: '/register/financial/expenditure/insert',
					icon: <FinansijskiObrazac />,
				},

				{
					name: 'financial/expenditures',
					title: 'Управљање издацима/Изворима финансирања',
					url: '/register/financial/expenditures',
					icon: <UpravljanjeFinansijskihIzvestaja />,
				},
			],
		},
	];

	const filteredMenuList = useMemo(() => {
		if (!user) return menuList;
		return menuList
			.map((section) => ({
				...section,
				subMenus: section.subMenus?.filter((sub: any) => {
					if (!sub?.roles?.length) return true;

					return sub.roles.includes(user?.roleView?.name);
				}),
			}))

			.filter((section) => section.subMenus?.length > 0);
	}, [user]);

	return (
		<div className='w-full h-full flex flex-row justify-start min-w-0 overflow-x-hidden'>
			<Sidebar menuList={filteredMenuList} />
			<div className='w-full min-w-0 overflow-x-hidden'>
				<Outlet />
			</div>
		</div>
	);
}

export default Register;
